import {HttpClient}          from '@angular/common/http';
import {environment}         from "../environments/environment";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";

export function translateLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, `${environment.s3}i18n/`, '.json');
}
